module.exports = __webpack_public_path__ + "img/zm-icon.cdec07e4.png";